import type { ContactSearchResult } from '../../types/contact'

export function flagDuplicateNames(results: ContactSearchResult[]): Set<string> {
  const byName = new Map<string, string[]>()
  for (const c of results) {
    const key = c.fullName.trim().toLowerCase().replace(/\s+/g, ' ')
    byName.set(key, [...(byName.get(key) ?? []), c.id])
  }
  const dup = new Set<string>()
  for (const ids of byName.values()) if (ids.length > 1) ids.forEach((id) => dup.add(id))
  return dup
}
